module.exports = __webpack_public_path__ + "img/page16_text.8350296d.png";